<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col>
            <h1>
              <v-btn color="primary" x-small text @click="goBack">
                <v-icon left> fa fa-angle-left </v-icon>
              </v-btn>
              Aulas
            </h1>
          </v-col>
        </v-row>
        <v-card v-if="gestaoDeAula">
          <v-card-text>
            <v-row style="color: black">
              <v-col cols="12">
                <h4>Turma: {{ gestaoDeAula.turma ? gestaoDeAula.turma.descricao : "- - -" }}</h4>
                <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
                <h4>
                  Carga horária:
                  {{
                    gestaoDeAula.carga_horaria
                      ? gestaoDeAula.carga_horaria
                      : "[ SEM CARGA HORÁRIA ]"
                  }}
                </h4>
                <div>
                  <v-row>
                    <v-col cols="5">
                      <h4>
                        Professor {{ parseInt(gestaoDeAula.is_hp, 10) == 1 ? "HP" : "" }}:
                        {{ gestaoDeAula.professor.nome }}
                      </h4>
                    </v-col>
                    <v-col cols="6">
                      <v-avatar color="indigo" size="25" class="ms-3">
                        <v-icon dark> mdi-account-circle </v-icon>
                      </v-avatar>
                      <v-chip class="ms-3" small color="primary darken-2">
                        Aulas confirmadas: {{ total_de_aulas_confirmadas_do_prof_efetivo }}
                      </v-chip>
                      <v-chip class="ms-3" small color="primary lighten-1">
                        Aulas aguardando confirmação:
                        {{ total_de_aulas_aguardando_confirmacao_do_prof_efetivo }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row
              v-for="(prof_auxiliar, index) in professores_auxiliares"
              :key="index"
              style="color: black"
            >
              <v-col cols="12">
                <v-row :key="index">
                  <v-col cols="5">
                    <h4 style="font-size: 14px">
                      Professor{{ parseInt(prof_auxiliar.is_hp, 10) == 1 ? " auxiliar" : "" }}:
                      {{ prof_auxiliar.professor.nome }}
                      <!-- {{ parseInt(prof_auxiliar.is_hp, 10) == 1 ? "HP" : "" }} -->
                    </h4>
                  </v-col>
                  <v-col cols="6">
                    <v-avatar color="indigo" size="25" class="ms-3">
                      <v-icon dark> mdi-account-circle </v-icon>
                    </v-avatar>
                    <v-chip class="ms-3" small color="primary">
                      Aulas confirmadas:
                      {{ prof_auxiliar.total_de_aulas_confirmadas_do_prof_auxiliar || 0 }}
                    </v-chip>
                    <v-chip class="ms-3" small color="primary">
                      Aulas aguardando confirmação:
                      {{
                        prof_auxiliar.total_de_aulas_aguardando_confirmacao_do_prof_auxiliar || 0
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="py-2">
                <v-btn-toggle borderless>
                  <v-btn value="left" @click="() => openModalMonth(1)">
                    <span class="hidden-sm-and-down">Frequência</span>
                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn value="center" @click="() => openModalMonth(2)">
                    <span class="hidden-sm-and-down">Aulas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="gestaoDeAula.turma.curso_id !== 10"
                    value="right"
                    @click="() => diarioNotas()"
                  >
                    <span class="hidden-sm-and-down">Notas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="gestaoDeAula.turma.curso_id === 10"
                    value="right"
                    @click="() => RelatorioBNCCTurma()"
                  >
                    <span class="hidden-sm-and-down">Relatório BNCC</span>
                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn value="right" @click="() => verHistoricoAulas()">
                    <span class="hidden-sm-and-down">Histórico de aulas</span>

                    <v-icon right> mdi-poll </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-col cols="12" class="pt-3 px-0 mt-3">
          <div class="d-flex justify-space-between">
            <div>
              <v-btn color="success" @click="() => criarAula(gestaoDeAula)" class="mr-2"
                >Criar Aula</v-btn
              >
            </div>
            <v-text-field
              v-model="search"
              class="ml-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-btn color="primary" @click="selecionarTodos" class="mb-3 mt-3" x-small>{{
          itensSelecionados.length ? "Desmarcar Todos" : "Selecionar Todos"
        }}</v-btn>
        <v-btn
          v-if="itensSelecionados.length"
          color="red"
          outlined
          @click="excluirSelecionados"
          class="mb-3 mt-3 ml-4"
          x-small
          >Excluir Selecionados</v-btn
        >
        <v-data-table
          :headers="table.headers"
          :items="aulasList"
          :loading="carregandoAulas"
          :items-per-page="itemsPerPage"
          :custom-filter="dataTableFilter"
          :search="search"
          class="elevation-1"
          @update:items-per-page="updateItemsPerPage"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="aula.estaDeletado ? ['deleted'] : []"
                v-for="(aula, i) in items"
                :key="aula.id"
              >
                <td>
                  <v-checkbox
                    @click="verificarSelecaoIndividual()"
                    v-model="aula.selected"
                  ></v-checkbox>
                </td>
                <td>{{ aula.id }}</td>
                <td>{{ aula.data_formatada }}</td>
                <td>
                  <e-situacao-aula :aula="aula" :i="i" @alterarSituacao="alterarSituacao" />
                  <v-chip
                    class="ml-2"
                    v-if="aula.descricaoSituacao === 'Aula em conflito'"
                    color="orange"
                    x-small
                    dark
                    @click="() => verificaSituacao(aula.id)"
                  >
                    ?</v-chip
                  >
                </td>

                <td><e-tipo-aula-snippet :aula="aula" /></td>
                <td class="text-left">
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        label
                        color="primary"
                        class="text-center"
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        Horários
                      </v-chip>
                    </template>
                    <span>
                      <div v-if="aula.horarios && aula.horarios.length > 0">
                        <div v-for="(horarioId, index) in aula.horarios" :key="index">
                          <p>{{ getHorarioDescricao(horarioId) }}</p>
                        </div>
                      </div>
                      <div v-else-if="aula.horario">
                        <p>{{ aula.horario.descricao }}</p>
                      </div>
                      <div v-else>
                        <p>{{ aula.horarios }}</p>
                      </div>
                    </span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip
                    color="primary"
                    v-if="parseInt(gestaoDeAula.turma.notifiq, 10) === 1"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        :color="parseInt(aula.frequencia_notifiq, 10) === 1 ? 'primary' : 'info'"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => enableSubmit(aula)"
                      >
                        <span class="material-icons">
                          {{ parseInt(aula.frequencia_notifiq, 10) === 1 ? "link" : "link_off" }}
                        </span>
                      </v-btn>
                    </template>
                    <span>{{
                      parseInt(aula.frequencia_notifiq, 10) === 1
                        ? "Registro de presenca automático"
                        : "Registro de presenca manual"
                    }}</span>
                  </v-tooltip>
                  <!-- {{ aula }} -->
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verMotivoAula(aula)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>

                    <span>Visualizar aula </span>
                  </v-tooltip>
                  <v-tooltip v-if="!aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação'
                            ? !$can(['aulas.atualizarAposDefinirSituacao'])
                            : false) || !aula.can_edit_aula
                        "
                        :to="{
                          name: 'aulas.frequencia',
                          params: { gestaoDeAulaId, aula_id: aula.id },
                        }"
                      >
                        <v-icon small>fa fa-thumbs-up </v-icon>
                      </v-btn>
                    </template>
                    <span>Lançar Frequência</span>
                  </v-tooltip>

                  <!-- para bloquear as aulas -->
                  <!-- v-if="aula.metodologia == null && aula.turma.curso_id == 10" -->
                  <v-tooltip v-if="!aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação' &&
                          aula.descricaoSituacao !== 'Aula em conflito'
                            ? true
                            : false) || !aula.can_edit_aula
                        "
                        @click="() => editarAula(aula, gestaoDeAula)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Aula</span>
                  </v-tooltip>
                  <v-tooltip v-if="!aula.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!aula.can_edit_aula"
                        @click="() => deletarAula(aula)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar Aula</span>
                  </v-tooltip>
                  <v-tooltip v-if="aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarAula(aula)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar Aula </span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <v-alert
            class="mt-2"
            style="text-align: center"
            type="orange"
            v-if="aulasConflitadasEncontradas"
          >
            Procurando aulas em conflitos
          </v-alert>

          <h2 class="mt-4">Aulas conflitadas</h2>
          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-if="aulasConflitadas.length <= 0">
                  <td>SEM AULAS EM CONFLITOS</td>
                </tr>
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </v-row>
    <e-drawer-motivo-aula v-model="verMotivo" :horario="horario" :aula="aula">
    </e-drawer-motivo-aula>
    <e-drawer-historico-aulas v-model="openDrawer" :gestao_id="parseInt(gestaoDeAulaId, 10)">
    </e-drawer-historico-aulas>
    <!-- Dialog -->
    <e-modal-select-month-aula
      :dialog="dialog"
      @dialogChange="dialog = $event"
      :gestao_id="gestaoDeAulaId"
      :tipo_diario="tipo_diario"
    ></e-modal-select-month-aula>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="removerRegistroPeloNotifiq"
    >
    </e-modal-confirm>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  props: {
    gestaoDeAulaId: {
      required: true,
      type: [String, Number],
    },
  },
  data() {
    return {
      horarioArray: [],
      horarios: [],
      horario: null,
      itensSelecionados: [],
      aulasConflitadasEncontradas: false,
      aulasConflitadas: [],
      aulasEmConflitos: false,
      dataTableFilter,
      aulasList: [],
      carregandoAulas: false,
      relatorio: [],
      total_de_aulas_confirmadas_do_prof_efetivo: 0,
      total_de_aulas_aguardando_confirmacao_do_prof_efetivo: 0,
      professores_auxiliares: [],
      itemsPerPage: 10,

      gestaoDeAulas: null,
      aula_notifiq: null,
      confirmDialog: false,
      objectModal: {
        title: "Notifiq",
        message:
          "Essa aula está sendo rigistrada automaticamente pelo notifiq, deseja realmente deixar esse registro manual?",
      },
      verMotivo: false,
      dialog: false,
      openDrawer: false,
      tipo_diario: 0,
      aula: {},
      gestaoDeAula: null,
      search: "",
      table: {
        headers: [
          { text: "Selecionar", value: "", sortable: false },
          { text: "#", value: "id" },
          { text: "Data", value: "data_formatada" },
          { text: "Situação", value: "situacao" },
          { text: "Tipo", value: "tipo" },
          { text: "Horário", value: "horario_descricao" },
          {
            text: "Ações",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
    };
  },
  async mounted() {
    await this.loadData();

    const savedItemsPerPage = localStorage.getItem("itemsPerPage");
    if (savedItemsPerPage) {
      this.itemsPerPage = parseInt(savedItemsPerPage, 10);
    }
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  methods: {
    updateItemsPerPage(value) {
      this.itemsPerPage = value;
      localStorage.setItem("itemsPerPage", value);
    },
    async excluirSelecionados() {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar estes itens?",
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando as Aulas");
              try {
                await this.$services.aulasService.deletarAulasEmLote(this.itensSelecionados);
                this.$toast.success("Aulas deletadas com sucesso");
                await this.loadData();
                this.itensSelecionados = [];
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    selecionarTodos() {
      if (this.itensSelecionados.length) {
        this.aulasList = this.aulasList.map((aula) => {
          return { ...aula, selected: false };
        });
      } else {
        this.aulasList = this.aulasList.map((aula) => {
          return { ...aula, selected: true };
        });
      }
      this.itensSelecionados = this.aulasList.filter((mat) => mat.selected === true);
    },
    verificarSelecaoIndividual() {
      this.itensSelecionados = this.aulasList.filter((mat) => mat.selected === true);
    },
    enableSubmit(aula = null) {
      this.confirmDialog = !this.confirmDialog;
      if (aula) {
        this.aula_notifiq = {
          ...aula,
          frequencia_notifiq: parseInt(aula.frequencia_notifiq, 10) === 1 ? 0 : 1,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
        };
        return;
      }
      this.aula_notifiq = aula;
    },
    goBack() {
      this.$router.push({ name: "gestoesDeAulas" });
    },
    async removerRegistroPeloNotifiq() {
      this.$loaderService.open("Carregando relátorio");
      try {
        if (this.aula_notifiq) {
          await this.$services.aulasService.atualizarRegistroNotifiq(this.aula_notifiq);
          await this.loadData();
          // this.$set(this.aulasList, this.index_aula_notifiq, this.aula_notifiq);
        }
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.confirmDialog = !this.confirmDialog;
      this.$loaderService.close();
    },
    openModalMonth(tipo_diario) {
      this.dialog = true;
      this.tipo_diario = parseInt(tipo_diario, 10);
    },
    criarAula(gestaoDeAula) {
      this.$router.push({
        name: gestaoDeAula.turma.curso_id === 10 ? "aulasInfantis.create" : "aulas.create",
        params: {
          gestaoDeAulaId: gestaoDeAula.id,
        },
      });
    },
    async diarioNotas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioNotas(this.gestaoDeAulaId);
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async RelatorioBNCCTurma() {
      try {
        this.$loaderService.open("Carregando relátorio");
        await this.$services.relatoriosService.relatorioBNCCTurma(
          parseInt(this.gestaoDeAula.turma.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
    },
    verMotivoAula(aula) {
      this.verMotivo = !this.verMotivo;
      this.aula = aula;
    },
    editarAula(aula, gestaoDeAula) {
      this.$router.push({
        name: gestaoDeAula.turma.curso_id === 10 ? "aulasInfantis.edit" : "aulas.edit",
        params: { aula_id: aula.id },
      });
    },
    async alterarSituacao(Objeto) {
      this.$set(this.aulasList, Objeto.i, Objeto.aulaAtualizada);
      await this.loadData();
    },
    async verificaSituacao(aula_id) {
      this.aulasEmConflitos = !this.aulasEmConflitos;
      const data = await this.$services.aulasService.listarAulasEmConflitos(aula_id);
      this.aulasConflitadas = data.data;
      if (data.data.length === 0) {
        this.$services.aulasService.atualizarSituacaoDaAula(aula_id).then(() => {
          // this.$router.go();
          this.$forceUpdate();
          window.location.reload();
        });
      }
    },
    async loadData() {
      this.carregandoAulas = true;
      if (this.total_de_aulas_confirmadas_do_prof_efetivo !== 0) {
        this.total_de_aulas_confirmadas_do_prof_efetivo = 0;
      }

      if (this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo !== 0) {
        this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo = 0;
      }

      this.$loaderService.open("Carregando Aulas");

      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.gestaoDeAulaId
        );

        this.aulasList = await response.aulas;
        this.aulasList = this.aulasList.map((aula) => {
          return { ...aula, selected: false };
        });

        const response_auxiliares = await this.$services.gestoesDeAulasService.pegarAuxiliar(
          parseInt(this.$route.params.gestaoDeAulaId, 10)
        );

        this.professores_auxiliares = await response_auxiliares.auxiliares;
        if (this.aulasList.length > 0) {
          this.aulasList.forEach((aula) => {
            if (aula?.situacao === this.$constants.situacoesAulasTexto.confirmada) {
              this.total_de_aulas_confirmadas_do_prof_efetivo += 1;
            }
            if (
              aula?.situacao === this.$constants.situacoesAulasTexto.aguardando ||
              aula?.situacao === "" ||
              aula?.situacao === null
            ) {
              this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo += 1;
            }
          });
        }

        this.professores_auxiliares.forEach((auxiliar_atual, index) => {
          // Verificar e inicializar valores undefined
          if (
            typeof this.professores_auxiliares[index]
              .total_de_aulas_confirmadas_do_prof_auxiliar === "undefined"
          ) {
            this.professores_auxiliares[index].total_de_aulas_confirmadas_do_prof_auxiliar = 0;
          }
          if (
            typeof this.professores_auxiliares[index]
              .total_de_aulas_aguardando_confirmacao_do_prof_auxiliar === "undefined"
          ) {
            this.professores_auxiliares[
              index
            ].total_de_aulas_aguardando_confirmacao_do_prof_auxiliar = 0;
          }
          auxiliar_atual.aulas.forEach((aula) => {
            if (aula?.situacao === this.$constants.situacoesAulasTexto.confirmada) {
              this.professores_auxiliares[index].total_de_aulas_confirmadas_do_prof_auxiliar += 1;
            }
            if (
              aula?.situacao === this.$constants.situacoesAulasTexto.aguardando ||
              aula?.situacao === "" ||
              aula?.situacao === null
            ) {
              this.professores_auxiliares[
                index
              ].total_de_aulas_aguardando_confirmacao_do_prof_auxiliar += 1;
            }
          });
        });

        this.gestaoDeAula = response.payload.gestaoDeAula;
        this.relatorio = response.payload.relatorio;
        this.horario = response.payload.horarios;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.carregandoAulas = false;
    },
    async deletarAula(aula) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Aula");
              try {
                await this.$services.aulasService.deletar(aula);
                this.aulasList = this.aulasList.filter((item) => item.id !== aula.id);
                this.$toast.success("Aula deletada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    recuperarAula(aula) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Aula");
              try {
                await this.$services.aulasService.recuperarAula(aula);
                this.$toast.success("Aula recuperada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    async verHistoricoAulas() {
      this.openDrawer = !this.openDrawer;
    },
    getHorarioDescricao(horarioId) {
      const horario = this.horario?.find((h) => h.id === horarioId);
      return horario ? horario.descricao : "";
    },
  },
};
</script>

<style></style>
